/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Gazlevel1Inputs */



/**
* | output |
* | --- |
* | "Gas level" |
*
* @param {Br_History_Key_Gazlevel1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_gazlevel1 = /** @type {((inputs?: Br_History_Key_Gazlevel1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Gazlevel1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Gas level")
	return /** @type {LocalizedString} */ ("Niveau de gaz")
});
export { br_history_key_gazlevel1 as "br_history_key_gazLevel" }